<template>
  <div class="wrapper">
    <div class="search-bg wrapper center">
      <div class="search-box center-wrapper">
        <el-col :span="11">
          <div
            class="left-intro"
          > 
          <img src="../assets/img/left-star.png" alt="" class="left-star">
            <img src="../assets/img/smlogo.png" alt="" class="first-logo">
            <p>查证书&nbsp;&nbsp;学知识</p>
            <div class="sm-star">
              <span>就上甄宝阁</span>
              <img src="../assets/img/right-star.png" alt="" class="right-star">
            </div>
            <div class="multi-type">
                <img src="../assets/img/multi-one.svg" alt="">
                <img src="../assets/img/multi-two.svg" alt="">
                <img src="../assets/img/multi-three.svg" alt="">
                <img src="../assets/img/multi-four.svg" alt="">
                <img src="../assets/img/multi-five.svg" alt="">
            </div>  
          </div>
        </el-col>
        <el-col :span="13">
          <el-form
            ref="form"
            :model="form"
            label-width="70px"
            :rules="rules" 
          >
            <el-form-item label="" required prop="source">
              <el-select 
                v-model="form.source"
                placeholder="请输入检测站名称"
                filterable 
                clearable
                :remote="true"
                :popper-append-to-body="false" 
                :loading="loading"
                :remote-method="handleQualityStation"
                @change="selctItem"
                popper-class="selectFrom"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-office-building"
                ></i>
                <el-option
                  v-for="item in options"
                  v-if="item.source"
                  :key="item.id"
                  :label="item.name"
                  :value="item.source"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" required prop="gem_no">
              <el-input
                placeholder="请输入证书编号"
                prefix-icon="el-icon-search"
                v-model="form.gem_no"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="cer_code">
              <el-input
                placeholder="请输入查询码或重量"
                prefix-icon="el-icon-search"
                v-model="form.cer_code"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onSubmit('form')">查询</el-button>
            </el-form-item>
            <div class="tip-box">
              <span class="tip">提示:&nbsp;若证书无查询码/重量则无需输入。若您未查询到结果，可能数据正在上传，给您带来的不便，敬请谅解！</span>
            </div>
          </el-form>
        </el-col>
      </div>
    </div>
    <div class="message">
      <div class="title-box">
        <h1>珠宝快讯</h1>
        <p>每天Get国际最新珠宝行业讯息</p>
      </div>
      <div class="msg-box center-wrapper">
       <JewelsMeaasge :dataList = "newsList" :key="num"/>
      </div>
    </div>
    <div class="message expert-info">
      <div class="title-box">
        <h1>业内专家</h1>
        <p>国内资深珠宝检测专家，专业的事交给专业的人来做</p>
      </div>
      <div class="expert-box center-wrapper">
        <div class="expert-one-box">
          <div
            v-for="(item,index) in infoList"
            :key="index"
            class="item-box"
          >
            <ExpertInfo :infoItem="item" />
          </div>
        </div>
        <div class="more center">
          <a @click="toExpert">MORE&nbsp;>>></a>
        </div>
      </div>
    </div>
    <div class="message partner center-wrapper">
          <div class="title-box">
            <h1>合作伙伴</h1>
            <p>与多家权威检测机构合作，数据更全面准确</p>
          </div>
          <div class="partner-info center-wrapper">
               <div class="animation-box">
                  <div class="line-odd">
                    <img src="../assets/img/partner-1.png" alt="">
                    <img src="../assets/img/partner-1.png" alt="">
                  </div>
                  <div class="line-even">
                    <img src="../assets/img/partner-2.png" alt="">
                    <img src="../assets/img/partner-2.png" alt="">
                  </div>
                  <div class="line-even">
                    <img src="../assets/img/partner-3.png" alt="">
                    <img src="../assets/img/partner-3.png" alt="">
                  </div>
                  <div class="line-odd">
                    <img src="../assets/img/partner-4.png" alt="">
                    <img src="../assets/img/partner-4.png" alt="">
                  </div>
               </div>
          </div>
    </div>
  </div>
</template>

<script>
import JewelsMeaasge from "../components/JewelsMeaasge.vue";
import ExpertInfo from "../components/ExpertInfo.vue";
import {fetchQualityStation, certificate, newsList, experts, stationList} from '../api/api';
export default {
  name: "Certificate",
  components: {
    JewelsMeaasge,
    ExpertInfo
  },
  data() {
    return {
      form: {
        source: "",
        gem_no: "",
        cer_code: ""
      },
      rules:{
         source: [
            { required: true, message: '请输入检测站名称' },
          ],
          gem_no: [
            { required: true, message: '请输入证书编号'}
          ],
      },
      loading: false,
      options: [],
      infoList: [],
      num:0,
      newsList:[]
    };
  },
  mounted() {
      this. handleExpertInfo();
      this. readList ();
  },
  methods: {
     readList () {
      newsList({per_page: 12, page: 1}).then(r => {
        if (r.data?.data.length) {
            this.newsList = r.data.data.map(item => {
            item.content = item.content.replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&quot;/ig, '"').replace(/&amp;nbsp;/ig, ' ').replace(/<[^>]+>/g,"")
            return item
          })
        }else {
          this.newsList = [];
        }
        this.num = 1;
      })
    },
    selctItem(e) {
    },
    handleQualityStation(query){
       if (query !== '') { 
        this.loading = true;
        stationList({
            keyword:query
        }).then(res=>{
          this.loading = false;
          this.options = res.data.data
        })
       } else {
          this.options = [];
       }
    },
    handleExpertInfo() {
      experts({
          page: 1,
          per_page: 4
      }).then(res => {
        if(res.data.data.length > 3) {
          this.infoList = res.data.data.slice(0,4);
        } else {
          this.infoList = res.data.data;
        }
      }).catch((err) => {
         console.log('err',err)
      })
    },
    toExpert() {
      this.$router.push('/Expert');
      window.scroll(0,0);
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.form
              certificate(params).then(r => {
              this.$router.push( { path: "/queryResults", query: { isTrueResults: r.data.code === 1000,  ...params} });
            })
          } else {
            return false;
          }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.left-intro {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
   .first-logo {
      width: 150px;
      height: 150px;
     object-fit: none;
   }
   p {
      padding-top: 10px;
      text-shadow: 0px 2.34px 0px rgba(255, 255, 255, 0.85);
      font-size: 50px;
      font-weight: 700;
   }
   .sm-star {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .right-star {
        position: absolute;
        left: 255px;
      }
   }
   span {
    display: inline-block;
    padding: 20px 0;
    letter-spacing: 12.76px;
    font-size: 21.26px;
    font-weight: 400;
   }
   .multi-type {
      width: 80%;
      display: flex;
      justify-content: center;
      align-items: center;
   }
   .left-star {
     position: absolute;
     top:20px;
     left: 20px;
   }
}
.search-bg {
  height: 620px;
  width: 100%;
  background: url('../assets/img/bigBg.png') 100% 100%;
  .search-box {
    display: flex;
    background: #ffffff;
    height: 480px;
    box-shadow: 0px 4px 50px rgba(122, 145, 158, 0.25);
    border-radius: 14px;
    padding: 50px 90px 40px 70px;
    .search-left {
      width: 100%;
      height: 100%;
      background: #2093ca;
    }
  }
  .el-select,
  .el-button {
    width: 100%;
  }
  ::v-deep .el-select .el-input__inner {
    cursor: auto;
  }
  .el-button {
    background: #2093ca;
    color: #ffffff;
    font-size: 20px;
    letter-spacing: 4px;
  }
  .tip-box {
    height: 80%;
    margin-left: 70px;
    line-height: 20px;
    .tip {
      color: rgba(128, 128, 128, 1);
      font-size: 14px;
    }
  }
}

.search-bg ::v-deep .el-input__inner,
.el-button {
  height: 54px !important;
  border: 1px solid #2093ca;
}

.message {
  height: auto;
  width: 100%;
  padding-bottom: 50px;
  background: rgba(247, 247, 247, 1);
  .title-box {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // padding: 46px 0 30px;
    h1 {
      color: rgba(0, 0, 0, 0.74);
      font-size: 30px;
      font-weight: 700;
      padding-top: 60px;
      padding-bottom: 30px;
    }
    p {
      color: rgba(0, 0, 0, 0.74);
      font-size: 16px;
      font-weight: 400;
      padding-bottom: 40px;
    }
  }
  .msg-box {
    height: 460px;
  }
}
.expert-info {
  background: rgba(240, 240, 240, 1);
  height: 713px;
  .expert-box {
    height: 70%;
    .expert-one-box {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      .item-box {
        width: 330px;
        height: 410px;
      }
    }
    .more {
      font-size: 16px;
      font-weight: 400;
      color: #2093ca;
      align-items: flex-end;
      cursor: pointer;
      padding-top:50px;
      // height: 8%;
      a {
        border-bottom: 1px solid #2093ca;
      }
    }
  }
}
.partner {
    background: #ffffff;
    .partner-info {
       height: 72%;
       .animation-box {
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          img {
              width: 50%;
              display: inline-block;
          }
          .line-odd {
            width: 3976px;
            -webkit-animation: scrollToRight 36s linear infinite;
            animation: scrollToRight 36s linear infinite;
          }
          .line-even {
               width: 3976px;
              -webkit-animation: scrollToRight 30s linear infinite;
              animation: scrollToRight 30s linear infinite;
          }
       }
    }
}
@keyframes scrollToRight {
    from {
      -webkit-transform: translate3d(-25%, 0, 0);
      transform: translate3d(-25%, 0, 0);
    }
    to {
        -webkit-transform: translate3d(25%, 0, 0);
        transform: translate3d(25%, 0, 0);
    }
}
::v-deep .selectFrom .el-select-dropdown__item.selected{
   color:rgba(32, 147, 202, 1)!important;
}
</style>
